import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("#home");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);

      const sections = navLinks.map(link =>
        document.querySelector(link.href)
      );

      sections.forEach(section => {
        if (!section) return;
        const rect = section.getBoundingClientRect();
        if (rect.top <= 120 && rect.bottom >= 120) {
          setActive(`#${section.id}`);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 w-full z-50">

      {/* Legal Bar */}
      <div className="bg-black text-gray-400 text-xs py-2 px-4 flex flex-wrap justify-center gap-x-3 gap-y-1 text-center">
        <span>GST: 27AAZFP5671P1ZY</span>
        <span className="hidden sm:inline">|</span>
        <span>FSSAI: 11524027000362</span>
        <span className="hidden sm:inline">|</span>
        <span>📧 pmdsupermarket@gmail.com</span>
        <span className="hidden sm:inline">|</span>
        <span>📞 9623969912</span>
      </div>

      {/* Welcome Bar */}
      <div className="bg-red-600 text-white text-sm text-center py-2">
        ⭐ Welcome to Galaxy Super Market — Nashik's trusted neighbourhood store |
        <a href="https://wa.me/919623969912" className="ml-2 underline font-semibold">
          WhatsApp: 9623969912
        </a>
      </div>

      {/* Main Navbar */}
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-white/95 backdrop-blur-lg shadow-lg"
            : "bg-white"
        }`}
      >
        <div className="flex items-center justify-between px-6 md:px-20 py-3">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" onClick={(e) => handleNavClick(e, '#home')}>
            <img src="/logo.png" alt="logo" className="w-12" />
            <div>
              <div className="text-gray-900 font-bold text-lg" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                Galaxy Super Market
              </div>
              <div className="text-red-500 text-xs font-semibold tracking-widest">
                FRESH · QUALITY · VALUE
              </div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8 text-gray-800">
            {navLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`font-medium transition ${
                  active === link.href
                    ? "text-red-500"
                    : "hover:text-red-500"
                }`}
              >
                {link.label}
              </a>
            ))}

            <a
              href="https://wa.me/919623969912"
              className="bg-red-500 text-white px-5 py-2 rounded-full font-semibold hover:bg-red-600 transition flex items-center gap-2"
            >
              📲 Order Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-800 text-2xl"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden bg-white text-gray-800 px-6 transition-all duration-300 overflow-hidden ${
            menuOpen ? "max-h-96 pb-6" : "max-h-0"
          }`}
        >
          <div className="flex flex-col gap-4 pt-4">
            {navLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`font-medium transition ${
                  active === link.href
                    ? "text-red-500"
                    : "hover:text-red-500"
                }`}
              >
                {link.label}
              </a>
            ))}

            <a
              href="https://wa.me/919623969912"
              className="bg-red-500 text-white px-4 py-2 rounded-full text-center font-semibold"
              onClick={() => setMenuOpen(false)}
            >
              Order on WhatsApp
            </a>
          </div>
        </div>

      </div>
    </header>
  );
}